export default __webpack_public_path__ + "static/media/select-an-environment.25cf1a3a.png";